import {combineReducers} from 'redux';

import user from './pages/user/user';
import login from './pages/user/login';
import verification from './pages/user/verification';
import trans from './pages/trans';
import addTrans from './pages/trans/addTrans';
import accumulative from './pages/trans/accumulative';
import settlements from './pages/trans/settlements';
import modalEditPersonalInfo from './partials/modals/modalEditPersonalInfo';
import modalEditEmail from './partials/modals/modalEditEmail';
import modalEditMobile from './partials/modals/modalEditMobile';
import modalEditMobileWarning from './partials/modals/modalEditMobileWarning';
import modalEditMobileVerifyOne from './partials/modals/modalEditMobileVerifyOne';
import modalEditMobileVerifyTwo from './partials/modals/modalEditMobileVerifyTwo';
import modalLogOut from './partials/modals/modalLogOut';
import modalSuccessMsg from './partials/modals/modalSuccessMsg';
import modalProductRating from './partials/modals/modalProductRating';
import allLoaders from './loaders';
import custom_snackbar from './snackbar';
import general from './general';
import categories from './categories';
import categoryProducts from './pages/category/categoryProducts';
import productDetails from './pages/product/productDetails';
import headerDesktop from './partials/header/headerDesktop';
import headerMobile from './partials/header/headerMobile';
import shoppingCart from './shoppingCart';
import shipping from './pages/checkout/shipping';
import modalAddresses from './partials/modals/modalAddresses';
import modalAddAddress from './partials/modals/modalAddAddress';
import modalAddCustomAddress from './partials/modals/modalAddCustomAddress';
import addresses from './pages/user/addresses';
import orders from './pages/user/orders';
import orderDetails from './pages/user/orderDetails';
import bottomSheetEditPersonalInfo from './pages/user/sheets/bottomSheetEditPersonalInfo';
import productsMobile from './pages/category/productsMobile';
import main from './pages/main';
import modalStory from './partials/modals/modalStory';
import searchProducts from './pages/search';
import sheetProductComments from './pages/product/sheetProductComments';
import bestSelling from './pages/bestSelling';
import amazingOffers from './pages/amazingOffers';
import flashSale from './pages/flashSale';

export default combineReducers({
    user, 
    login,
    verification,
    trans,
    addTrans,
    accumulative,
    settlements,
    modalEditPersonalInfo,
    modalEditEmail,
    modalEditMobile,
    modalEditMobileWarning,
    modalEditMobileVerifyOne,
    modalEditMobileVerifyTwo,
    modalLogOut, 
    modalSuccessMsg, 
    allLoaders,
    custom_snackbar,
    general,
    categories,
    categoryProducts,
    productDetails,
    headerDesktop,
    headerMobile,
    shoppingCart,
    shipping,
    modalAddresses,
    modalAddAddress,
    modalAddCustomAddress,
    modalProductRating,
    addresses,
    orders,
    orderDetails,
    bottomSheetEditPersonalInfo,
    productsMobile,
    main,
    modalStory,
    searchProducts,
    sheetProductComments,
    bestSelling,
    amazingOffers,
    flashSale,
});
